import { Stack, styled } from "@mui/material";
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import InfiniteScroller from "react-infinite-scroller";
import { LoadingArea } from "@/components/elements/Loading/Loading";
import { TVocabularyWord } from "@/infrastructure/adapters/vocabulary";
import { VocabularyWordCard } from "@/features/vocabulary/components/VocabularyWordCard";
import { background, divider } from "@/theme/colors";
import { rounded, spacing } from "@/theme/variables";

const PAGE_SIZE = 20;

type TVocabularyWordListProps = {
  words: TVocabularyWord[];
  showFurigana: boolean;
  resetKey: string;
  scrollParent: HTMLElement | null;
};

export const VocabularyWordList: FC<TVocabularyWordListProps> = ({ words, showFurigana, resetKey, scrollParent }) => {
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  const getScrollParent = useCallback(() => scrollParent, [scrollParent]);

  useEffect(() => {
    setVisibleCount(PAGE_SIZE);
  }, [resetKey]);

  const visibleWords = useMemo(() => words.slice(0, visibleCount), [words, visibleCount]);
  const hasMore = visibleCount < words.length;

  const loadMore = useCallback(() => {
    setVisibleCount((prev) => prev + PAGE_SIZE);
  }, []);

  return (
    <WordListContainer gap={1}>
      <InfiniteScroller
        loadMore={loadMore}
        hasMore={hasMore}
        initialLoad={false}
        useWindow={false}
        getScrollParent={getScrollParent}
        loader={
          <Stack key="loader" py={2}>
            <LoadingArea />
          </Stack>
        }
      >
        <Stack gap={1} px={2}>
          {visibleWords.map((word) => (
            <VocabularyWordCard key={word.id} word={word} showFurigana={showFurigana} />
          ))}
        </Stack>
      </InfiniteScroller>
    </WordListContainer>
  );
};

const WordListContainer = styled(Stack)({
  minHeight: 400,
  paddingTop: spacing.sm,
  paddingBottom: spacing.sm,
  borderRadius: rounded.xs,
  backgroundColor: background.white,
  border: `1px solid ${divider.high}`,
});
